import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
	@Output() doSearch = new EventEmitter<any>();
	public form: UntypedFormGroup;
	public loadingResults = false;
	@Input() public minSearchLength: number;
	public searchChanged: Subject<string> = new Subject<string>();
	public searchChangedSubscription: any;

	constructor(private _subscriptionService: SubscriptionService,
				private _formBuilder: UntypedFormBuilder) {
		this.searchChangedSubscription = this.searchChanged.pipe(debounceTime(1500)).subscribe((searchCriteria) => {
			this.doSearch.emit(searchCriteria);
			this.loadingResults = false;
		});
	}

	changed(text: string): void {
		if ((text && text.length >= this.minSearchLength) || (!text)) {
			this.loadingResults = true;
			this.searchChanged.next(text);
		}
	}

	clearSearch(): void {
		this.form.controls.search.setValue('');
		this.doSearch.emit('');
	}

	createForm() {
		this.form = this._formBuilder.group({
			search: ['', [Validators.minLength(this.minSearchLength)]]
		});
		this.form.valueChanges.subscribe((formValue) => {
			this.changed(formValue.search);
		});
	}

	ngOnDestroy(): void {
		this._subscriptionService.unSubscribe([this.searchChangedSubscription]);
	}

	ngOnInit(): void {
		this.createForm();
	}

}
